import { Table } from '@clari/iris-table';
import React from 'react';
import { ActionComposeEnum } from '@groove/action-compose/constants';
import ActionCompose from '@groove/action-compose';
import { useGetActionsInfinitely } from 'Modules/ActionsRewrite_2024/hooks/useGetActions';
import useBuildDefaultColumnOrder from 'Modules/ActionsRewrite_2024/components/columnDefs/useBuildDefaultColumnOrder';
import useColumnDefinitionsBuilder from 'Modules/ActionsRewrite_2024/components/columnDefs/useColumnDefinitionsBuilder';

import '@clari/iris-react/style.css';
import '@clari/iris-table/style.css';

const ActionsTable: React.FC = () => {
  const defaultColumnOrder = useBuildDefaultColumnOrder();
  const columnDefinitionsBuilder =
    useColumnDefinitionsBuilder(defaultColumnOrder);

  const { data: actionPages, fetchNextPage } = useGetActionsInfinitely(
    columnDefinitionsBuilder.columnsQueryKey
  );
  const actions = actionPages?.pages?.flatMap(actionPage => actionPage.data);

  return (
    <>
      <div style={{ height: '60vh', width: 'auto' }}>
        <Table
          id="iris-table-1"
          rowData={actions}
          suppressScrollOnNewData // To prevent jumping to the top upon receiving new data
          onBodyScrollEnd={event => {
            if (event.direction === 'vertical') fetchNextPage();
          }}
          defaultColDef={{
            cellStyle: params => ({
              display: 'flex',
              alignItems: 'center',
            }),
          }}
          suppressFieldDotNotation={false} // To enable accessing nested properties via `.`
          columnDefs={columnDefinitionsBuilder.columnDefinitions}
        />
      </div>
      <div className="absolute right-[50px] bottom-0  shadow-2xl">
        <ActionCompose showHeader initialState={ActionComposeEnum.MINIMIZED} />
      </div>
    </>
  );
};

export default ActionsTable;
